import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions, Button, CircularProgress,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { JournalEntry } from '../types';

interface DeleteDialogProps {
  open: boolean;
  entry: JournalEntry | null;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({ open, entry, loading, onConfirm, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'error.main' }}>
      <WarningIcon fontSize="small" />
      Удалить запись?
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        Вы собираетесь удалить:{' '}
        <strong>{entry?.materialName}</strong>
        {entry?.serialNumber && ` (серия ${entry.serialNumber})`}
        {entry?.expiryDate && `, срок годности ${entry.expiryDate}`}.
        <br />
        Это действие нельзя отменить.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>Отмена</Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} /> : undefined}
      >
        {loading ? 'Удаление…' : 'Удалить'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteDialog;
